import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

const Items = ({ values }) => {
  return (
    <div>
      {values && values.items ? (
        <TableContainer className="max-h-[500px] overflow-auto">
          <Table className="min-w-[650px]" size="small">
            <TableHead>
              <TableRow>
                <TableCell className="!text-gray-500">#</TableCell>
                <TableCell className="!text-gray-500">Item Id</TableCell>
                <TableCell className="!text-gray-500">Product</TableCell>
                <TableCell className="!text-gray-500">NOL</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {values.items.map((j, ind) => (
                <TableRow key={ind}>
                  <TableCell>{values.items.length - ind}</TableCell>
                  <TableCell>{j.id}</TableCell>
                  <TableCell>{j.prodTitle}</TableCell>
                  <TableCell>{j.nol}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <span className="text-[18px] font-medium p-[15px]">Loading...</span>
      )}
    </div>
  );
};

export default Items;
